export const formatConfigFilter = {
    createYear: 'year',
    month: 'month',
    from: 'start_date',
    to: 'end_date',
    areas: 'areas_ids',
    departments: 'departments_ids',
    catalog: 'catalog_ids'
}